import { render, staticRenderFns } from "./AdminMattermost.vue?vue&type=template&id=95f06e78&"
import script from "./AdminMattermost.vue?vue&type=script&lang=js&"
export * from "./AdminMattermost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports